export const environment = {
  production: true,
  recaptchaKey: '6Lf8t3srAAAAAMNV3d9GLYs9c7O5Pa6N1YsUH3ei',
  apiHost: '//assess.tycg.gov.tw/data',
  basehref: '',
  backendUrl: 'https://assess.tycg.gov.tw/backend'
};
